module.exports = __webpack_public_path__ + "img/face_with_monocle.6839ba85.gif";